import React, { useState } from 'react'
import { connect } from 'react-redux'
import to from 'await-catch'
import {
	FormHeader,
	FormTitle,
	InputsContainer,
	ButtonsContainer,
	LinkButton,
	FormContainer,
	Wrapper,
	FormContent
} from '../../ui/form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import Input from '../../ui/input'
import { Button } from '../../ui/button'
import { hideLoader, showLoader } from '../../../actions'
import Feedback from '../../feedback'

const ChangeUserPhone = ({ auth,patient, dispatch }) => {
	const history = useHistory()
	const [newPhone, setNewPhone] = useState('')
	const [repeatPhone, setRepeatPhone] = useState('')
	const [loading, setLoading] = useState(false)
	const [isChanged, setIsChanged] = useState({ changed: false, error: false })

	const handleSubmit = async e => {
		e.preventDefault()
		
	/*	setLoading(true)
		dispatch(showLoader())

		const [err] = await to(changePhone(auth?.idUsuario, patient?.telefono || '', newPhone))

		if (err) {
			setIsChanged({ changed: true, error: true })
			setLoading(false)
			dispatch(hideLoader())
			return
		}

		setIsChanged({ changed: true, error: false })
		setLoading(false)
		dispatch(hideLoader())
		*/
	}

	const handleCancel = () => {
		history.push('/inicio/mis-datos')
	}

	return isChanged.changed ? (
		<Feedback
			title={!isChanged.error ? 'Actualizamos tu número de celular' : 'Hubo un error al actualizar tu número de celular'}
			bodyText={!isChanged.error ? 'Tus datos fueron actualizados con éxito' : 'Por favor volvé a intentarlo más tarde'}
			buttonLabel="Volver al inicio"
			onClickButton={handleCancel}
			isError={isChanged.error}
		/>
	) : (
		<Wrapper>
			<form onSubmit={handleSubmit}>
				<FormContainer justifyMobile="center" align="start" margin="0 0">
					<FormHeader align="start">
						<FormTitle align="left">Cambiar celular</FormTitle>
					</FormHeader>
					<FormContent>
						<InputsContainer>
							<Input
								fullWidth
								label={'Número de celular actual'}
								placeholder={patient?.telefono || ''}
								value={patient?.telefono || ''}
								disabled
							/>
							<Input
								fullWidth
								label={'Nuevo número de celular'}
								placeholder={'Ingresá tu nuevo número de celular'}
								value={newPhone}
								onChange={e => setNewPhone(e.target.value)}
								disabled
							/>
							<Input
								fullWidth
								label={'Repetir número de celular'}
								placeholder={'Repetí tu nuevo número de celular'}
								value={repeatPhone}
								onChange={e => setRepeatPhone(e.target.value)}
								disabled
							/>
						</InputsContainer>
						<ButtonsContainer>
							<Button label={'Guardar cambios'} $variant="primary" size="mobile" type="submit" disabled={loading} />
							<LinkButton type="button" onClick={handleCancel}>Cancelar</LinkButton>
						</ButtonsContainer>
					</FormContent>
				</FormContainer>
			</form>
		</Wrapper>
	)
}

const mapStateToProps = (state = {}) => ({
	auth: state.auth || {},
	patient: state.patient || {}
})

export default connect(mapStateToProps)(ChangeUserPhone)